import { inject } from '@angular/core';

import {
  injectTellentAppKind,
  ORG_GUID,
  TellentClientOneDomainLegacyRedirect,
  TellentPageConfig,
} from '@core/tellent-types';
import { injectTellentAppUrlBuilder } from '@core/tellent-util';

export function redirectToOneDomainIfLegacyDomainVisited(
  isOneDomainEnabled: boolean,
  oneDomainUrl: string,
  preservePath: boolean = false,
) {
  if (!isOneDomainEnabled) {
    return false;
  }

  const isOneDomainHost = oneDomainUrl.includes(window.location.hostname);

  if (isOneDomainHost) {
    return false;
  }

  const urlBuilder = injectTellentAppUrlBuilder();
  const appKind = injectTellentAppKind();
  const orgGuid = inject(ORG_GUID)!;

  const redirectConfig = preservePath ? createOneDomainRedirectLink() : undefined;

  const redirectUrl = urlBuilder(appKind, redirectConfig, orgGuid);

  window.open(redirectUrl, '_self');

  return true;
}

const createOneDomainRedirectLink = () => {
  const url = new URL(window.location.toString());
  // legacy hash api link, convert to pathname
  if (url.pathname === '/' && url.hash) {
    url.pathname = url.hash.replace('#', '');
    url.hash = '';
  }

  const path = decodeURIComponent(url.href).replace(url.origin, 'tellent://');

  return <TellentPageConfig<typeof TellentClientOneDomainLegacyRedirect>>{
    id: TellentClientOneDomainLegacyRedirect,
    params: { path },
  };
};
